module.exports = __webpack_public_path__ + "fonts/analogue-webfont.259a8b2.woff2";